import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_ZONE_RESET = 'POST_ZONE_RESET';
export const POST_ZONE_LOADING = 'POST_ZONE_LOADING';
export const POST_ZONE_SUCCESS = 'POST_ZONE_SUCCESS';
export const POST_ZONE_REJECT = 'POST_ZONE_REJECT';

//* ACTIONS ------------------------------------------------
export const postZoneReset = () => ({ type: POST_ZONE_RESET });
export const postZoneLoading = () => ({ type: POST_ZONE_LOADING });
export const postZoneSuccess = (payload) => ({ type: POST_ZONE_SUCCESS, payload });
export const postZoneReject = (payload) => ({ type: POST_ZONE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postZoneRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/api/Zones`, options);
};


